export default "__VITE_ASSET__tkcBWLYR__"